import { render, staticRenderFns } from "./EditAccountNickname.vue?vue&type=template&id=276e2ab0&scoped=true"
import script from "./EditAccountNickname.vue?vue&type=script&lang=js"
export * from "./EditAccountNickname.vue?vue&type=script&lang=js"
import style0 from "./EditAccountNickname.vue?vue&type=style&index=0&id=276e2ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e2ab0",
  null
  
)

export default component.exports